export const getHCSCProviderTagFromResourceId = (
  resourceId,
  hcscProviderTagsConfig,
) => {
  if (!resourceId || typeof resourceId !== 'string') return null;

  const configs =
    Array.isArray(hcscProviderTagsConfig) && hcscProviderTagsConfig.length > 0
      ? hcscProviderTagsConfig
      : [];

  const matched = configs.find(
    ({ resources, tag }) =>
      tag && Array.isArray(resources) && resources.includes(resourceId),
  );
  return matched ? matched.tag : null;
};
